

































































import CollapseTransition from '@/components/collapseTransition/collapseTransition'; // 导入过渡函数
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { Component, Vue } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { doublePrevention, temporaryWorkServer } from '@/api/installServer';
import DetailView from './detailPage.vue';

@Component({
  components: { CollapseTransition, PagingUnit, DetailView },
  mixins: [TableStripe],
})
export default class RiskFollowUp extends Vue {
  private editRoleFlag: any = 1; // 控制显示 列表 页面
  private row: any = {}; // 控制显示 详情 页面
  // 查询分页表单
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 0; // 总共多少条数据

  private dateValue: any = '';
  private pickerOptions: any = {
    shortcuts: [
      {
        text: '最近一周',
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', [start, end]);
        },
      },
      {
        text: '最近一个月',
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit('pick', [start, end]);
        },
      },
      {
        text: '最近三个月',
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit('pick', [start, end]);
        },
      },
    ],
  };
  // 表单数据对象
  formData: any = {
    search: '',
    startTime: '',
    endTime: '',
  };
  // table 数据对象
  tableData: any = [];

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    this.formData.search = JSON.parse((localStorage as any).getItem('userInfo')).staffName;
    // 获取分页数据
    this.getPageData();
  }
  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getPageData() {
    if (this.dateValue && this.dateValue.length) {
      this.formData.startTime = this.dateValue[0];
      this.formData.endTime = this.dateValue[1];
    } else {
      this.formData.startTime = '';
      this.formData.endTime = '';
    }
    const pageSearchData: any = {};
    for (const key in this.formData) {
      if ((this.formData as any)[key]) {
        // 如果搜索表单里面的这一项有值，那么就加入到 分页搜索数据中
        (pageSearchData as any)[key] = (this.formData as any)[key];
      }
    }
    // 发起接口请求，获取分页数据
    doublePrevention
      .getHandyCheckList({
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        ...pageSearchData,
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 点击分页按钮触发，改变内容
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    // 调用获取分页数据
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  resetFormData() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    (this.$refs.formRef as any).resetFields();
    this.dateValue = '';
    this.formData.startTime = '';
    this.formData.endTime = '';
    this.getPageData();
  }
  deleteData(id: any) {
    this.$confirm('确认要删除该条数据吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        doublePrevention.deleteHandyCheck(id).then((res: any) => {
          if (res.code === '200') {
            this.$message.success('数据删除成功！');
            this.getPageData();
          } else {
            this.$message.error(res.msg);
          }
        });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
  }

  // 表格详情
  detailView(data: any) {
    this.row = data; // 将该行 id 传递到编辑页面
    this.editRoleFlag = 2; // 进入表格详情页面
  }
  private handleInfoResponse() {
    this.editRoleFlag = 1;
    this.getPageData();
  }
}
